import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { InstallationFeaturesStore } from '@store';
import {
  DeviceIds,
  Feature,
  FeatureNames,
  IsActiveProperty,
  RoomsChannelsOptimizedControlCommands,
} from '@vi-iot/client/index';

@Component({
  selector: 'app-obng-src-settings-intelligent-heat-control',
  templateUrl: './obng-src-settings-intelligent-heat-control.component.html',
  styleUrls: ['./obng-src-settings-intelligent-heat-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObngSrcSettingsIntelligentHeatControlComponent {
  @Input({ required: true }) optimizedControl: Feature<
    IsActiveProperty,
    RoomsChannelsOptimizedControlCommands
  >;
  @Input({ required: true }) circuitId: string;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  onToggleChange(toggle: MatSlideToggle): void {
    const channelId = this.optimizedControl.feature.split('.')[2];

    this.installationFeaturesStore.updateFeature(
      FeatureNames.roomsChannelsOptimizedControl(channelId),
      toggle.checked,
      'active',
      'active',
      'setActive',
      this.optimizedControl.gatewayId,
      DeviceIds.RoomControl
    );
  }
}
